<script setup lang="ts">
import SidepanelActivity from '@/components/SidepanelActivity.vue';
import SidepanelWrapper from '@/components/SidepanelWrapper.vue';
</script>

<template>
	<SidepanelWrapper>
		<SidepanelActivity />
	</SidepanelWrapper>
</template>
